import React from 'react'
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import IncomeFlexiReportsChild from "./IncomeFlexiReportsChild";

const IncomeFlexiReports = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <IncomeFlexiReportsChild />
      </CardBackground>
    </MainTemplate>
  )
}

export default IncomeFlexiReports